import axios from 'axios'

// 创建 axios 实例
const request = axios.create({
    baseURL: 'https://ebike-api.vinkacloud.com', // 正式服
    // baseURL: 'https://ebike-api-dev.vinkacloud.com', // 测试服
    // baseURL: 'http://127.0.0.1:8060', // 本地
    timeout: 10000, // 请求超时时间
    headers: {
        'Content-Type': 'application/json'
    }
})

// 请求拦截器
request.interceptors.request.use(
    config => {
        // 可以在这里添加 token 等
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// 响应拦截器
request.interceptors.response.use(
    response => {
        return response.data
    },
    error => {
        console.error('API Error:', error)
        return Promise.reject(error)
    }
)

export default request
